import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'

import { AdminLayout } from '@/layouts'
import { ProtectedRoute } from '@/router/ProtectedRoute'

import { catalogRoutes } from './admin/catalogs.routes'
import { frameworkRoutes } from './admin/framework.routes'
import { organizationRoutes } from './admin/organization.routes'
import { userRoutes } from './admin/user.routes'

export const adminRoutes: RouteObject = {
  path: 'admin',
  element: (
    <ProtectedRoute
      requiredRoles={['Administrador', 'Gerente', 'Consultor']}
      unauthorizedComponent={<Navigate to="/dashboard" replace />}
    />
  ),
  children: [
    {
      element: <AdminLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="/admin/catalogs" replace />
        },
        ...userRoutes,
        ...frameworkRoutes,
        ...organizationRoutes,
        catalogRoutes
      ]
    }
  ]
}
